import { useQueryClient } from 'react-query';

import type { OpeningScheduleRequest } from 'generated/index';

import { mutations, queryKeys } from 'RestAPIs/rapini';

import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

/** Creates a schedule, or replaces the one with {@code openingScheduleId} as a whole. */
export const useSaveOpeningSchedule = (
  planUnitId: number,
  openingScheduleId: string | undefined,
  onSaved: () => void
) => {
  const queryClient = useQueryClient();
  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.getOpeningSchedules.name);
      // What the plan unit - and every unit under it - effectively has changes with its own schedules.
      queryClient.invalidateQueries(queryKeys.getEffectiveOpeningHours.name);
      showSuccessSnackbar();
      onSaved();
    },
    onError: showError
  };

  const create = mutations.useCreateOpeningSchedule(planUnitId, options);
  const update = mutations.useUpdateOpeningSchedule(
    planUnitId,
    openingScheduleId ?? '',
    options
  );

  const save = (request: OpeningScheduleRequest) =>
    openingScheduleId === undefined
      ? create.mutate(request)
      : update.mutate(request);

  return { save, isSaving: create.isLoading || update.isLoading };
};
